import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Route} from '../../enum/route';
import {Roles} from '../../enum/roles';
import {CompanyService} from '../../services/company-service/company.service';
import {Company} from '../../model/proposal/company';
import {OfferType} from '../../enum/offer-type';
import {Observable} from 'rxjs';
import {CompanyPage} from '../../model/company-page';
import {User} from '../../model/user';
import {CompanyAppState} from '../../store/company/reducers/company.reducer';
import {Store} from '@ngrx/store';
import {selectMemberPosterView} from '../../store/company/selectors/company.selectors';
import {CompanyPageActions} from '../../store/company/actions/company.actions';

@Component({
    selector: 'app-member-overview',
    templateUrl: './member-overview.component.html',
    styleUrls: ['../../../styles/profile.scss', '../profile-company/profile-company.component.scss', './member-overview.component.scss', '../../components/offer-overview/offer-overview.component.scss'],
    standalone: false
})
export class MemberOverviewComponent implements OnInit{

  Route = Route;
  companyPages$: Observable<CompanyPage[]> = this.companyService.getAllCompanies();
  displayedColumns = ['role', 'companyName', 'address', 'representatives', 'phoneNumber', 'email', 'action'];
  memberPosterView: boolean = true;


  constructor(private readonly router: Router,
              public companyService: CompanyService,
              public companyStore: Store<CompanyAppState>) { }

  protected readonly Roles = Roles;

  ngOnInit(): void {
    this.companyStore.select(selectMemberPosterView).subscribe(poster => this.memberPosterView = poster);
  }

  navigateToCompanyProfile(companyId) {
    this.router.navigate([Route.COMPANY_PROFILE, companyId]);
  }

  navigateToUserProfile(userId) {
    this.router.navigate([Route.USER_PAGE, userId]).then();
  }

  protected readonly OfferType = OfferType;

  toggleMemberView(poster) {
    this.memberPosterView = poster;
    this.companyStore.dispatch(CompanyPageActions.memberPosterView({ memberPosterView: poster }));
  }

  filterByRole(companies: Company[], role: Roles) {
    return companies.filter(company => company.companyRole === role.toString());
  }

  hasRepresentativeRole(users: User[]) {
    return users.filter(user => user.isRepresentative).length > 0;
  }
  companiesWithRepresentatives(companies: CompanyPage[]){
    return companies
      .filter(company => company.users.some(user => user.isRepresentative))
      .sort((c1, c2) => {
        // In case of empty or null roles, localeCompare doesn't work and causes an error.
        // Role set to 'ZZZ' string so that the companies without a role are put to the end of the array.
        const role1 = c1.companyRole || 'ZZZ';
        const role2 = c2.companyRole || 'ZZZ';
        return role1.localeCompare(role2);
      });
  }

}
